import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-form-model-item', {
    staticClass: "disclaimer",
    attrs: {
      "prop": "accept"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }), _c('a-checkbox', {
    model: {
      value: _vm.formData.accept,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "accept", $$v);
      },
      expression: "formData.accept"
    }
  }, [_vm._v(" " + _vm._s(_vm.t('我已阅读并同意')) + " ")]), _c('a', {
    attrs: {
      "target": "_blank",
      "data-permission": "my_account_add_or_edit_payment_account_disclaimer",
      "id": "my_account_add_or_edit_payment_account_disclaimer",
      "data-sign": "my_account_add_or_edit_payment_account_disclaimer",
      "fbu-analyse-name": $t("\u300A\u514D\u8D23\u58F0\u660E\u300B")
    },
    on: {
      "click": _vm.handleNotice
    }
  }, [_vm._v(_vm._s(_vm.t('《免责声明》')))])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };